import request from '@/libs/request'


// 设备列表
export function deviceListApi (data = {}) {
  return request({
    url: `device/info`,
    method: 'get',
    params: data
  })
}

// 设备详情
export function deviceInfoApi (id) {
  return request({
    url: `device/info/${id}`,
    method: 'get'
  })
}

// 设备修改
export function deviceSaveApi (data) {
  return request({
    url: `device/info`,
    method: 'post',
    data: data
  })
}

// 设备历史记录 列表
export function deviceLogListApi (data = {}) {
  return request({
    url: `device/log`,
    method: 'get',
    params: data
  })
}



